<template>
    <div class="hsa-direct-deposit-report container-fluid full-height flex-column" v-if="!busy">
        <h4 class="mt-2">Hsa Direct Deposit Daily Reports</h4>
        <div class="row">
            <amf-datepicker label="Nacha Received Date" v-model="receivedDate" :validator="$v.receivedDate"/>

            <amf-button v-if="!isForEmployer" class="mt-4" :onClick="getHsaDeposits">Search</amf-button>
            <amf-input v-if="!isForEmployer" no-tracking class="pt-0" v-model="filterAmfCode" label="Filtered By AmfCode"></amf-input>
            <div class="radio-group">
                <input   id="morning" name="morning" type="radio" v-model="filterTimeOfDay" value="morning">
                <label for="morning">Morning</label>

                <input  id="evening" name="evening" type="radio" v-model="filterTimeOfDay" value="evening">
                <label for="evening">Evening</label>
            </div>
            <amf-button class="mt-4" :onClick="filter">Filter</amf-button>
            <amf-button v-if="isFiltered" class="btn-success ml-2 mt-4" :onClick="clearFilter" style="margin-top:24px;">Clear Filter</amf-button>


        </div>

        <div class="row scroll-y">
            <div class="form-group col-12" v-if="!busy">
                    <div class="form-group" v-if="!filteredDeposits || filteredDeposits.length == 0">There are no deposit records for the selected date.</div>
                    <table class="fixed-table-header table table-sm table-hover" v-if="filteredDeposits && filteredDeposits.length > 0">
                        <thead>
                            <th>Employer Name</th>
                            <th>AmfCode</th>
                            <th>Participant</th>
                            <th>Account Type</th>
                            <th>Account Number</th>
                            <th>Routing Number</th>
                            <th>Amount</th>
                            <th>Return Code</th>
                            <th>Trace Number</th>
                            <th>Received Date</th>
                        </thead>
                        <tbody>
                            <tr v-for="d in filteredDeposits" :key="d.nachaDirectDepositId">
                                <td>{{d.employerName}}</td>
                                <td>{{d.amfCode}}</td>
                                <td>{{d.fullName}}</td>
                                <td>{{d.planType}}</td>
                                <td>{{d.accountNumber}}</td>
                                <td>{{d.routingNumber}}</td>
                                <td>{{$formatters.money(d.amount)}}</td>
                                <td>{{getReturnCode(d.returnCode)}}</td>
                                <td>{{d.traceNumber}}</td>
                                <td>{{$formatters.dateTime(d.dateReceived)}}</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    </div>

</template>

<script>
import changeTracker from "../framework/utils/change-tracker";
export default {
    data() {
        return {
          busy:false,
          receivedDate:null,
          allDeposits:[],
          filteredDeposits:[],
          isFiltered: false,
          filterAmfCode: null,
          filterTimeOfDay: null,
        }
    },
    methods:{
        async getHsaDeposits()
        {
            this.busy = true;
            if(this.isForEmployer) {
                this.deposits = await romeApi.get(`hsa-direct-deposit/${this.employerId}/daily-reports`);
            }
            else{
                if(!this.receivedDate) this.receivedDate = moment().toDate();
                this.deposits = await romeApi.get(`hsa-direct-deposit/daily-reports`, {date: this.receivedDate});
            }

            this.filteredDeposits = this.deposits;
            this.busy = false;
        },
        filter()
        {
            this.filteredDeposits = this.deposits;
``
            if(this.filterTimeOfDay)
            {
                switch(this.filterTimeOfDay)
                {
                    case "morning":
                        this.filteredDeposits = this.deposits.filter(d => {
                            const itemTime = new Date(d.dateReceived);
                            const itemHours = itemTime.getHours();
                            return itemHours < 12
                        });
                        break;

                    case "evening":
                        this.filteredDeposits = this.deposits.filter(d => {
                            const itemTime = new Date(d.dateReceived);
                            const itemHours = itemTime.getHours();
                            return itemHours >= 12
                        });
                        break;
                }
            }
            if(this.receivedDate)
            {
                this.filteredDeposits = this.filteredDeposits.filter(d=>moment(d.dateReceived).isSame(this.receivedDate, 'day'));
            }

            if(this.filterAmfCode)
            {
                this.filteredDeposits = this.filteredDeposits.filter(d=> d.amfCode == this.filterAmfCode);
            }
            this.resetTracker();
        },
        clearFilter()
        {
            this.filterAmfCode = null;
            this.isFiltered = false;
            this.filteredDeposits = this.deposits;
            this.filterTimeOfDay = null;
            if(this.isForEmployer) this.receivedDate = null;
        },
        resetTracker()
        {
            this.isFiltered = true;
            changeTracker.clear();
        },
        getReturnCode(value)
        {
            return this.lookup("Nacha.ReturnCode").value(value);
        }
    },
    computed:
    {
        ...amfx.map('route', 'employerId'),
        isForEmployer()
        {
            return this.employerId != null;
        }
    },
    async created()
    {
        await this.getHsaDeposits();
    },
    validations() {
      return {
        receivedDate: v.build(v.required()),
      }
    },
}
</script>
<style scoped>
.hsa-direct-deposit-report
{
    background-color: #fff !important;
}
.radio-group {
  display: flex;
  align-items: center;
}
.radio-group input[type="radio"],
.radio-group label {
  margin-right: 10px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/finance/HsaDDFundingReport.vue